import NotificationsIcon from '@mui/icons-material/Notifications'
import SearchIcon from '@mui/icons-material/Search'
import { Box, Grid, InputAdornment, TextField as MuiTextField, Typography } from '@mui/material'
import { FC, useMemo, useState } from 'react'
import {
  Datagrid,
  DateField,
  DeleteButton,
  ListContextProvider,
  Pagination,
  TextField,
  useGetList,
  useList,
  useRecordContext,
  useTranslate,
} from 'react-admin'
import { Notificatie, Samenwerking } from '../../types/apiRequests'

const DetailPanel = () => {
  const record = useRecordContext<Notificatie>()
  return (
    <Typography variant='body1'>
      { record?.notificatieTekst }
    </Typography>
  )
}

const CollaborationsNotifications: FC = () => {
  const translate = useTranslate()
  const record = useRecordContext<Samenwerking>()
  const isClosed = record?.status === 'GESLOTEN'
  const [search, setSearch] = useState('')

  const { data, isLoading, error, refetch } = useGetList<Notificatie>(
    `samenwerkingen/${record?.id}/notificaties`,
    {
      filter: {},
      pagination: { page: 1, perPage: 1000 },
    }
  )

  const filtered = useMemo(() => {
    if (!data) return []
    if (!search.trim()) return data
    const q = search.toLowerCase()
    return data.filter(entry =>
      entry.notificatieTitel?.toLowerCase().includes(q)
      || entry.notificatieTekst?.toLowerCase().includes(q)
    )
  }, [data, search])

  const listContext = useList<Notificatie>({ data: filtered, isLoading, perPage: 10 })

  if (isLoading) return <div />
  if (error) {
    return (
      <Typography color="error">
        {translate('ra.notification.http_error')}
      </Typography>
    )
  }

  return (
    <Grid container spacing={3}>
      <Grid item md={12}>
        <Box
          sx={{
            border: 1,
            borderColor: 'grey.300',
            borderRadius: 1,
            p: 2,
            height: '100%',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center' }}>
              <NotificationsIcon sx={{ mr: '10px' }} fontSize="small" />
              {translate('show.notifications')}
            </Typography>
            <MuiTextField
              size="small"
              placeholder={translate('ra.action.search')}
              value={search}
              onChange={e => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
              sx={{ width: 250 }}
            />
          </Box>

          <ListContextProvider value={listContext}>
            <Datagrid
              expand={DetailPanel}
              rowClick={false}
              bulkActionButtons={false}
            >
              <DateField
                label="data.date"
                source="eventDatumTijd"
                showTime
              />
              <TextField
                label="data.title"
                source="notificatieTitel"
              />
              {!isClosed && (
                <DeleteButton
                  resource="notificaties"
                  mutationMode="pessimistic"
                  redirect={false}
                  mutationOptions={{ onSuccess: () => void refetch() }}
                />
              )}
            </Datagrid>
            <Pagination />
          </ListContextProvider>
        </Box>
      </Grid>
    </Grid>
  )
}

export default CollaborationsNotifications
